import { IconArrowOutOfBox } from '@sequencehq/core-components'
import { NodeTimeline } from 'Automations/components'
import { ExecutionSummaryComponent } from 'Automations/nodeDefinitions/types'
import {
  CancelledItem,
  FailedItem,
  hasCancelledTask,
  hasFailedTask
} from 'Automations/nodeDefinitions/executionSummaryUtils'
import { useAllUsers } from 'common/hooks/useUsers'
import { useMemo } from 'react'

export const ContractUploadedExecutionSummary: ExecutionSummaryComponent = ({
  tasks,
  automationExecution,
  isLatestNodeExecution
}) => {
  const { users } = useAllUsers()

  const performedBy = useMemo(() => {
    return (
      users.find(user => user.id === automationExecution.input?.requestorId)
        ?.email || automationExecution.input?.requestorEmail
    )
  }, [
    users,
    automationExecution.input?.requestorId,
    automationExecution.input?.requestorEmail
  ])

  const { fileName } = useMemo(() => {
    return {
      fileName: automationExecution.input?.fileName
    }
  }, [automationExecution.input?.fileName])

  const taskFailed = useMemo(() => hasFailedTask(tasks), [tasks])

  const taskCancelled = useMemo(() => hasCancelledTask(tasks), [tasks])

  if (taskFailed) {
    return (
      <FailedItem
        label="Contract upload failed"
        timestamp={automationExecution.createTime}
        isLatestNodeExecution={isLatestNodeExecution}
      />
    )
  }

  if (taskCancelled) {
    return (
      <CancelledItem
        label="Contract upload cancelled"
        timestamp={automationExecution.createTime}
        isLatestNodeExecution={isLatestNodeExecution}
      />
    )
  }

  return (
    <>
      <NodeTimeline.Item
        icon={<IconArrowOutOfBox />}
        showStem={!isLatestNodeExecution}
      >
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              fileName ? `Contract ${fileName} uploaded` : 'Contract uploaded'
            }
            performedBy={performedBy}
            timestamp={automationExecution.createTime}
          />
        </NodeTimeline.Title>
      </NodeTimeline.Item>
    </>
  )
}
